export default __webpack_public_path__ + "static/heroAnimation-de1ab973a91ddf03a6d39fa5177ae2ed.webm";